module.exports = __webpack_public_path__ + "assets/CoreData.8eee414e.svg";